// components/common/LoadingButton.jsx - With dark mode support
import React from "react";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import textTranslator from "../../utils/useTextTranslator";

const LoadingButton = ({
  loading,
  children,
  loadingText = textTranslator("Loading...", "UI") || "Loading...",
  className = "",
  loadingClassName = "",
  disabled = false,
  variant = "primary", // primary, secondary, danger
  ...props
}) => {
  const darkMode = useSelector((state) => state.settings.darkMode);
  const getVariantStyles = () => {
    if (darkMode) {
      switch (variant) {
        case "primary":
          return "bg-indigo-600 text-white hover:bg-indigo-700";
        case "secondary":
          return "bg-gray-700 text-white hover:bg-gray-600";
        case "danger":
          return "bg-red-600 text-white hover:bg-red-700";
        default:
          return "bg-indigo-600 text-white hover:bg-indigo-700";
      }
    } else {
      switch (variant) {
        case "primary":
          return "bg-indigo-600 text-white hover:bg-indigo-700";
        case "secondary":
          return "bg-gray-200 text-gray-700 hover:bg-gray-300";
        case "danger":
          return "bg-red-600 text-white hover:bg-red-700";
        default:
          return "bg-indigo-600 text-white hover:bg-indigo-700";
      }
    }
  };

  return (
    <motion.button
      variants={{
        hidden: { opacity: 0, x: -8 },
        visible: { opacity: 1, x: 0 },
      }}
      whileHover={{ x: 3 }}
      whileTap={{ scale: 0.98 }}
      className={`px-3 py-2 rounded text-sm max-sm:text-xs flex items-center justify-center gap-2 transition-colors ${
        loading || disabled ? "opacity-60 cursor-not-allowed" : ""
      } ${getVariantStyles()} ${className}`}
      disabled={loading || disabled}
      {...props}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span className={loadingClassName}>{loadingText}</span>
        </>
      ) : (
        children
      )}
    </motion.button>
  );
};

export default LoadingButton;
